import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import AppPage from '../../../AppPages';


export default class ForgotPassword extends Component {

    static contextTypes = { api: PropTypes.object };

    constructor(props){
        super(props);

        this.onFormChange = this.onFormChange.bind(this);
        this.changePassword = this.changePassword.bind(this);

        this.state = {};

    }

    onFormChange = ( {target} )=>{
        this.setState({ [target.name]: target.value});
    };

    changePassword = (e)=>{
        e.preventDefault();

        const {email} = this.state;

        if( !email )
            return;

        this.context.api.users.recoverPassword( email )
            .then(()=>{
                this.setState( {success:true, error:false} );
            })
            .catch(()=>{
                this.setState( {error:true} );
            })
    };

    render() {
        return (

            <AppPage>

                <div className="row">

                    <div className="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">

                        <form onChange={this.onFormChange} onSubmit={this.changePassword}>
                            <div className="card">

                                <div className="card-header">
                                    <h3 className="card-title" title='¿Cuál era? ¿Cuál era? Ya no me acuerdo'>Olvidé mi contraseña</h3>
                                </div>
                                {!this.state.success?
                                    <div className="card-content">

                                        { this.state.error?
                                            <Alert bsStyle='danger'>
                                                ¡Rayos!<br/>
                                                Hubo un error al enviar el mail. Inténtalo más tarde o contacta al soporte técnico.
                                            </Alert>:null}

                                        <div className="form-group">
                                            <label>Email</label>
                                            <input
                                                placeholder="Escribe tu email"
                                                className="form-control input-no-border"
                                                name='email'
                                                required
                                            />
                                        </div>
                                    </div>:
                                    <div className="card-content">
                                        <p> <strong className='text-success'>¡Éxito!</strong> Hemos enviado un correo con las instrucciones para cambiar la contraseña.</p>
                                    </div>}

                                {!this.state.success?
                                    <div className="card-footer text-center">
                                        <button
                                            type="submit"
                                            className="btn btn-fill btn-wd"
                                        >
                                            Enviar
                                        </button>
                                    </div>:null}

                            </div>
                        </form>
                    </div>

                </div>

            </AppPage>

        );
    }
}




// WEBPACK FOOTER //
// ./src/App/scenes/AppPages/scenes/ForgotPassword/index.js